<template>
  <div class="app-container">
    <div class="topbar">
      <div>
        <el-input v-model="watchInfoSearchValue" size="small" placeholder="" prefix-icon="el-icon-search"
                  class="search-input" clearable @keyup.enter.native="search()"/>
        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!watchInfoSearchValue"
                   @click.stop="search()">
          搜索
        </el-button>
      </div>

      <el-button type="success" size="small" @click="export2Excel">导出excel
      </el-button>

    </div>

    <el-table v-loading="loading" :data="watchInfoDataList" :header-cell-style="{ background: '#F5F7FA' }"
              style="width: 100%; margin-bottom: 20px" border>
      <el-table-column prop="userVideoWatchId" label="ID" align="center"></el-table-column>
      <el-table-column prop="userInfo" label="观看者" align="center" show-overflow-tooltip>
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="mobilePhone" label="手机" align="center"></el-table-column>
      <el-table-column prop="organization" label="单位" align="center"></el-table-column>
      <el-table-column prop="startTime" label="开始时间" align="center">
        <template #default='scope'>
          {{ scope.row.startTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="结束时间" align="center">
        <template #default='scope'>
          {{ scope.row.endTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column prop="watchTimeLength" label="观看时长(min)" align="center">
        <template #default="scope">
          {{ scope.row.watchTimeLength | formatSecond2Min }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :total="this.watchInfoPageOpt.totalCount" :page-size="this.watchInfoPageOpt.pageSize"
                   :current-page="this.watchInfoPageOpt.currentPage" @current-change="currentChange"/>
  </div>

</template>

<script>
import {getWatchUserList} from "@/api/mai/liveReviews/liveReviews";
import {handleRes} from "@/utils/handleRes";
import UserInfo from "@/components/UserInfo/UserInfo";
import {export_json_to_excel} from "@/vendor/Export2Excel";
import {getDisplayName} from "@/utils/userutil";

export default {
  name: "watchInfo",
  components: {UserInfo},
  props: {
    liveID: {
      Number
    }
  },
  data() {
    return {
      loading: false,
      watchInfoPageOpt: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
      watchInfoSearchValue: "",
      watchInfoDataList: [],
    }
  },
  created() {
    this.getViewWatchUserList()
  },
  methods: {
    currentChange(curPage) {
      this.watchInfoPageOpt.currentPage = curPage
      this.getViewWatchUserList()
    },
    search() {
      this.refreshList()
    },
    refreshList() {
      this.watchInfoPageOpt.currentPage = 1
      this.getViewWatchUserList()
    },
    /**
     * 观看信息
     * @param liveID
     */
    getViewWatchUserList() {
      const params = {
        liveId: this.liveID,
        keyWord: this.watchInfoSearchValue,
        pageNumber: this.watchInfoPageOpt.currentPage,
        pageSize: this.watchInfoPageOpt.pageSize,
        sortName: "",
        sortOrder: ""
      };
      this.loading = true;
      getWatchUserList(params).then(res => {
        handleRes(res, () => {
          this.watchInfoPageOpt.totalCount = res.data.total
          this.watchInfoDataList = res.data.rows
        })
        this.utils.stopLoading(this)
      })
    },
    export2Excel() {
      if(this.watchInfoDataList.length === 0){
        this.$message.info('没有要导出数据')
        return;
      }
      let {
        tName,
        tHeader,
        filterValue
      } = this.getExcelInfo()
      this.getAllViewWatchUserList(this.type, tName, tHeader, filterValue)
    },
    getExcelInfo() {
      let tName = '用户观看数据';
      let tHeader;
      let filterValue;
      tHeader = ['视频标题','ID', '观看者', '用户ID', '手机', '单位', '开始时间', '结束时间', '观看时长(min)']
      filterValue = [
        'videoTitle',
        'userVideoWatchId',
        'nickname',
        'userId',
        'mobilePhone',
        'organization',
        'startTime',
        'endTime',
        'watchTimeLength',
      ]
      return {
        tName,
        tHeader,
        filterValue
      }

    },
    getAllViewWatchUserList(type, tName, tHeader, filterValue) {
      this.loading = true;
      const params = {
        liveId: this.liveID,
        keyWord: this.watchInfoSearchValue,
        pageNumber: 1,
        pageSize: this.watchInfoPageOpt.totalCount,
        sortName: "",
        sortOrder: ""
      };

      getWatchUserList(params).then((res) => {
        let list = this.formatChatInfoTable(res.data.rows)
        let data = this.formatJson(filterValue, list)
        tName = res.data.rows[0].videoTitle
        export_json_to_excel({
          header: tHeader,
          data,
          filename: tName,
          autoWidth: true,
          bookType: "xlsx",
        })
        this.utils.stopLoading(this)
      });
    },
    /**
     * 格式化 JSON
     *
     * @param filterValue
     * @param jsonData
     */
    formatJson(filterValue, jsonData) {
      return jsonData.map(x => filterValue.map(y => {
        return x[y]
      }))
    },
    /**
     * 格式化 userInfoTable
     *
     * @param list
     */
    formatChatInfoTable(list) {
      let newList = list.map(item => {
        item.userName = item.firstName + item.lastName
        item.startTime = this.$options.filters["formatDateTime"](item.startTime)
        item.endTime = this.$options.filters["formatDateTime"](item.endTime)
        item.nickname = getDisplayName(item)
        item.watchTimeLength = this.$options.filters["formatSecond2Min"](item.watchTimeLength)
        return item
      })

      return newList
    },
  }

}
</script>

<style scoped>

</style>